import { create } from "zustand"

import {
  consentimentoPadrao,
  gravarConsentimento,
  lerConsentimento,
  type Consentimento,
} from "@/lib/consentimento"
import { limparPreferencias } from "@/lib/preferencias"
import { useThemeStore } from "@/stores/sessionStore"

type Escolha = Pick<Consentimento, "preferencias" | "analiticos">

interface ConsentimentoState {
  /** `true` após o usuário tomar uma decisão (aceitar/rejeitar/salvar). */
  decidido: boolean
  preferencias: boolean
  analiticos: boolean
  /** Banner de primeira visita visível. */
  bannerVisivel: boolean
  /** Modal "Personalizar preferências" aberto. */
  modalAberto: boolean
  aceitarTodos: () => void
  rejeitarOpcionais: () => void
  salvar: (escolha: Escolha) => void
  abrirPreferencias: () => void
  fecharPreferencias: () => void
}

function estadoInicial() {
  const salvo = lerConsentimento()
  if (salvo) {
    return {
      decidido: true,
      preferencias: salvo.preferencias,
      analiticos: salvo.analiticos,
      bannerVisivel: false,
    }
  }
  const padrao = consentimentoPadrao()
  return {
    decidido: false,
    preferencias: padrao.preferencias,
    analiticos: padrao.analiticos,
    bannerVisivel: true,
  }
}

export const useConsentimentoStore = create<ConsentimentoState>((set) => {
  const aplicar = (escolha: Escolha) => {
    gravarConsentimento(escolha)
    // Revogar preferências apaga o que foi guardado e volta o tema ao padrão.
    if (!escolha.preferencias) {
      limparPreferencias()
      useThemeStore.getState().setTheme("system")
    }
    set({ ...escolha, decidido: true, bannerVisivel: false, modalAberto: false })
  }

  return {
    ...estadoInicial(),
    modalAberto: false,
    aceitarTodos: () => aplicar({ preferencias: true, analiticos: true }),
    rejeitarOpcionais: () => aplicar({ preferencias: false, analiticos: false }),
    salvar: (escolha) => aplicar(escolha),
    abrirPreferencias: () => set({ modalAberto: true }),
    fecharPreferencias: () => set({ modalAberto: false }),
  }
})
